import styled, { css, createGlobalStyle } from 'styled-components'
import { color } from 'ui/themes/utils'

import FocalImage from 'ui/blocks/FocalImage'

export const HostStyles = createGlobalStyle`
  :host {
    --variation-select-border: 1px solid var(--color-border, ${color('Misc/Divider')});
    --variation-select-color: var(--color-typo, ${color('text')});
    --variation-select-background-color: var(--color-white, ${color('white')});
    --variation-select-font-size: 13px;
    --variation-select-font-family: var(--font-body, sans-serif);
    --variation-select-padding: 0 30px 0 10px;
    --variation-select-control-height: 38px;
    --variation-select-border-radius: 6px;

    --bundle-items-image-size: 50px;
    --bundle-items-image-border: 1px solid var(--color-border, ${color('Misc/Divider')});
    --bundle-items-image-border-radius: 6px;

    --bundle-items-cell-padding: 5px;

    --bundle-items-font-size: 15px;
    --bundle-items-font-family: var(--font-body, sans-serif);

    --bundle-items-background-color: var(--color-primary-background, ${color('white')});
    --bundle-items-color: var(--color-primary-foreground, ${color('text')});
  }

  * {
    box-sizing: border-box;
  }
`

const BundleItems = styled.div`
  position: relative;

  background-color: var(--bundle-items-background-color);
`

const Inner = styled.div`
  display: grid;
  grid-template-columns: max-content max-content 1fr;

  overflow-y: auto;

  ${({ height }) => height && css`
    max-height: ${height}px;
  `}
`

const BundleItem = styled.div`
  display: contents;

  ${FocalImage} {
    width: var(--bundle-items-image-size);
    height: var(--bundle-items-image-size);

    border: var(--bundle-items-image-border);
    border-radius: var(--bundle-items-image-border-radius);
  }
`

const BundleItemCell = styled.div`
  display: flex;
  align-items: center;

  padding: var(--bundle-items-cell-padding);

  font-size: var(--bundle-items-font-size);
  font-family: var(--bundle-items-font-family);

  color: var(--bundle-items-color);

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`

const BundleItemSelectWrapper = styled.div`
  position: relative;

  width: 100%;

  svg {
    position: absolute;

    color: var(--variation-select-color);
    fill: var(--variation-select-color);

    top: 50%;
    right: 10px;
    transform: translateY(-50%);

    width: 14px;
    height: 14px;

    pointer-events: none;
  }
`

const BundleItemSelect = styled.select`
  border: var(--variation-select-border);

  color: var(--variation-select-color);
  background-color: var(--variation-select-background-color);

  font-size: var(--variation-select-font-size);
  font-family: var(--variation-select-font-family);

  padding: var(--variation-select-padding);

  width: 100%;
  height: var(--variation-select-control-height);

  border-radius: var(--variation-select-border-radius);

  appearance: none;
`

const ScrollGradient = styled.div`
  position: absolute;

  left: 0;
  right: 0;

  height: 50px;
  width: 100%;

  z-index: 100;

  pointer-events: none;

  opacity: 0;

  background-image: linear-gradient(
    to bottom,
    color-mix(in srgb, var(--bundle-items-background-color) 0%, transparent) 15%,
    var(--bundle-items-background-color)
  );

  transition: opacity 0.15s cubic-bezier(0.18, 0.89, 0.32, 1.28);

  ${({ visible }) => visible && css`
    opacity: 1;
  `}

  ${({ side }) => {
    switch (side) {
      case 'top':
        return css`
          top: 0;
          background-image: linear-gradient(
            to top,
            color-mix(in srgb, var(--bundle-items-background-color) 0%, transparent) 15%,
            var(--bundle-items-background-color)
          );
        `
      case 'bottom':
        return css`
          bottom: 0;
          background-image: linear-gradient(
            to bottom,
            color-mix(in srgb, var(--bundle-items-background-color) 0%, transparent) 15%,
            var(--bundle-items-background-color)
          );
        `
    }
  }}
`

BundleItems.Inner = Inner
BundleItems.BundleItem = BundleItem
BundleItems.BundleItemCell = BundleItemCell
BundleItems.BundleItemSelectWrapper = BundleItemSelectWrapper
BundleItems.BundleItemSelect = BundleItemSelect
BundleItems.ScrollGradient = ScrollGradient

export default BundleItems
